//libs
import React, { memo } from 'react';

//components
import Price from 'shared/components/ProductV2/components/Price';

//context
import { useOverlaySheetContext } from 'shared/components/OverlaySheet/OverlaySheetContext';

//icons
import { useStoreIcon, IconName } from 'shared/icons';

//styles
import {
  HeaderContainer,
  HeaderContent,
  Cross,
  Description,
  Title,
  SubTitle,
  SizeSoldout,
  SelectedImage,
  ProductDetails,
  HeadingWithImage,
} from './styles';

//constants
import { SIMILAR_PRODUCTS, CROSS_SIZE } from './constants';

interface HeaderProps {
  selectedProduct: Listing.IProduct;
  isScroll: boolean;
}

const Header = ({ selectedProduct, isScroll }: HeaderProps) => {
  const { doHide } = useOverlaySheetContext();
  const CircleXDuotone = useStoreIcon(IconName.CIRCLE_X_DUOTONE);

  return (
    <>
      <HeaderContainer isScroll={isScroll}>
        <Cross onClick={doHide} data-at="cross-btn">
          <CircleXDuotone size={CROSS_SIZE} />
        </Cross>
        <HeadingWithImage>
          <SelectedImage
            src={selectedProduct.imageUrl}
            lazy={true}
            alt={`${selectedProduct.title} - ${selectedProduct.subTitle}`}
            data-test="similar-product-img"
            className="top-image"
          />
          <HeaderContent className="header-content">{SIMILAR_PRODUCTS}</HeaderContent>
        </HeadingWithImage>
      </HeaderContainer>
      <ProductDetails isScroll={isScroll}>
        <SelectedImage
          src={selectedProduct.imageUrl}
          lazy={true}
          alt={`${selectedProduct.title} - ${selectedProduct.subTitle}`}
          data-test="similar-product-img"
        />
        <Description>
          <Title>{selectedProduct.title}</Title>
          <SubTitle>{selectedProduct.subTitle}</SubTitle>

          <Price
            discount={selectedProduct.discount}
            discountedPrice={selectedProduct.discountedPrice}
            price={selectedProduct.price}
          />
          {!selectedProduct.isOutOfStock && (
            <SizeSoldout>{selectedProduct.messageSizeOutOfStock}</SizeSoldout>
          )}
        </Description>
      </ProductDetails>
    </>
  );
};

export default memo(Header);
